import { useCallback } from 'react';
import { mediaModuleUrl, mediaRoutes } from 'common/services';

type P = {
  id: string;
};

export const useGetMediaSource = () =>
  useCallback(({ id }: P) => new URL(mediaRoutes.resource({ id }), mediaModuleUrl).href, []);
